module.exports = __webpack_public_path__ + "static/media/tenge.79e3c502.svg";